import { render, staticRenderFns } from "./PageReclamations.vue?vue&type=template&id=3d9d1fc5&"
import script from "./PageReclamations.vue?vue&type=script&lang=js&"
export * from "./PageReclamations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d9d1fc5')) {
      api.createRecord('3d9d1fc5', component.options)
    } else {
      api.reload('3d9d1fc5', component.options)
    }
    module.hot.accept("./PageReclamations.vue?vue&type=template&id=3d9d1fc5&", function () {
      api.rerender('3d9d1fc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Commandes/PageReclamations.vue"
export default component.exports